import React from "react";
import GatsbyConfig from "../../../gatsby-config.js";
import moment from "moment";
import { setInLocal, buildPerksHTMLforTrip } from "../../utils/app-helpers";
import BookmarkArrow from "../partials/bookmark-arrow";
import SiteFooter from "../partials/site-footer";
import HelmetWrapper from "../partials/helmet-wrapper";
import SiteHeader from "../partials/site-header";
import TabbedContent from "../partials/tabbed-content";

const { siteMetadata: config } = GatsbyConfig;

export default class FaqPage extends React.Component {
  componentDidMount() {
    const { trip } = this.props;

    setInLocal("lsg.last-viewed-trip", trip);
  }

  render() {
    const { trip, location, metaTitle, metaDescription } = this.props;
    if (!trip) return <main />;

    const trips = Object.keys(config.trips);
    trips.splice(trips.indexOf(trip), 1);
    const tripData = config.trips[trip] || {};
    const year = tripData.dates.replace(/.*(\d{4})$/, "$1");
    const selectedKey =
      location && location.search.match(/tab=[^&]+/i)
        ? location.search.replace(/.*\??tab=([^&]+).*/g, "$1")
        : "all";
    const perksHTML = buildPerksHTMLforTrip(tripData);

    let otherTripLis = [];
    Object.keys(config.trips).forEach((key) => {
      if (key === trip) return;
      const otherTripData = config.trips[key];
      if (!otherTripData.available || otherTripData.hideLink) return;
      otherTripLis.push(`
        <li>
          <a href="/${key}#top">
            ${otherTripData.name} ${otherTripData.year}
            at ${otherTripData.venue}
          </a>
        </li>
      `);
    });

    const bookingHtml = `
      <h1>Booking your Trip</h1>
      <dl>
        <dt>What is the Love Song Couples Getaway?</dt>
        <dd>
          The Love Song Couples Getaway is a Christian-based vacation that
          will give you the chance to spend some much needed time with your
          spouse, delve deeper into the Word of God, hear from phenomenal
          speakers, worship with chart-topping Christian artists, and
          fellowship with other believers, all while enjoying a phenomenal
          resort, beaches, and picturesque landscapes.
        </dd>
      </dl>
      <dl>
        <dt>
          What is included in the Love Song Getaway
          | ${tripData.name} ${tripData.year} price?
        </dt>
        <dd>${perksHTML}</dd>
      </dl>
      ${
        trip === "maui2018"
          ? `
            <dl>
              <dt>
                Is the daily resort fee included in the trip price?
                What does it include?
              </dt>
              <dd>
              <p>
                Yes, for our travelers, the Love Song Couples Getaway has
                included the daily resort fee in the trip price, which
                includes the following:
              </p>
              <ul>
                <li>Enhanced High Speed Internet Service</li>
                <li>
                  Kapalua Resort Shuttle Services for travel within
                  Kapalua Resort
                </li>
                <li>Complimentary Photo Session</li>
                <li>Beach Chair Service</li>
                <li>Discounted Golf Fees & Preferred Tee Times</li>
                <li>
                  Cultural History Tours and Resort Activities
                  (Basketball, Tennis, Shuffleboard, Croquet)
                </li>
              </ul>
              </dd>
            </dl>
          `
          : trip === "maui2019"
          ? `
            <dl>
              <dt>
                Is the daily resort fee included in the trip price?
                What does it include?
              </dt>
              <dd>
              <p>
                Yes, for our travelers, the Love Song Couples Getaway has
                included the daily resort fee in the trip price, which
                includes the following:
              </p>
              <ul>
                <li>Enhanced High Speed Internet Service</li>
                <li>
                  Kapalua Resort Shuttle Services for travel within
                  Kapalua Resort
                </li>
                <li>Complimentary Photo Session</li>
                <li>Beach Chair Service</li>
                <li>Discounted Golf Fees & Preferred Tee Times</li>
                <li>
                  Cultural History Tours and Resort Activities
                  (Basketball, Tennis, Shuffleboard, Croquet)
                </li>
              </ul>
              </dd>
            </dl>
          `
          : trip === "maui2021"
          ? `
            <dl>
              <dt>
                Is the daily resort fee included in the trip price?
                What does it include?
              </dt>
              <dd>
                <p>
                  Yes, for our travelers, the Love Song Couples Getaway has
                  included the $48 Daily Resort Fee (Per Person) in the trip price, which
                  includes the following:
                </p>
                <ul>
                  <li>Self-Parking</li>
                  <li>High-Speed Internet</li>
                  <li>In-Suite Bottled Water for Two Replenished Daily</li>
                  <li>One hour snorkel equipment (two sets per suite per day, resort use only)</li>
                  <li>Pool and Beach Amenities including Sunscreen and After Sun Care</li>
                  <li>Hawaiian Canoe Experience</li>
                  <li>Weekly Cultural Activities</li>
                </ul>
              </dd>
            </dl>
          `
          : trip.match(/kauai/)
          ? `
            <dl>
              <dt>
                Is the daily resort fee included in the trip price?
                What does it include?
              </dt>
              <dd>
                <p>
                  Yes, for our travelers, the Love Song Couples Getaway has
                  included the daily resort fee in the trip price, which
                  includes the following:
                </p>
                <ul>
                  <li>Self-Parking</li>
                  <li>High-Speed Internet</li>
                  <li>Access to 24 hour Anara Spa Fitness Center</li>
                  <li>Fitness Classes</li>
                  <li>Coffee Maker in Room with Hawaiian Coffee and Tea</li>
                  <li>Two Complimentary Refillable Water Bottles with Purified Water Stations</li>
                  <li>Guided Sunrise Walk</li>
                  <li>Torch Lighting Ceremony</li>
                  <li>Ukulele, Lei-making and Hula Lessons</li>
                  <li>and more&hellip;</li>
                </ul>
              </dd>
            </dl>
          `
          : ""
      }
      <dl>
        <dt>How do we make a reservation?</dt>
        <dd>
          Making a reservation is easy!
          <a href="/${trip}/prices/">Book online today</a>.
        </dd>
      </dl>
      <dl>
        <dt>Can we book additional nights to the Love Song Couples Getaway?</dt>
        <dd>
          Yes, you can add-on up to 3 nights before and/or 3 nights after
          the dates of the trip at our great rates by
          <a href="/${trip}/contact-us/">contacting us</a>.
          Please note, space is limited & subject to availability,
          so the earlier you book your add-on nights, the better!
        </dd>
      </dl>
      <dl>
        ${
          trip === "maui2018"
            ? `
              <dt>Are there any suites available?</dt>
              <dd>
                Absolutely! If you want the ultimate experience, we recommend
                <a href="/${trip}/prices/?tab=suites">booking a suite</a>.
                We have a range of luxurious suite options available.
              </dd>
            `
            : trip === "maui2019"
            ? `
                <dt>Are there any suites available?</dt>
                <dd>
                  Absolutely! If you want the ultimate experience, we recommend
                  <a href="/${trip}/prices/?tab=suites">booking a suite</a>.
                  We have a range of luxurious suite options available.
                </dd>
              `
            : trip === "maui2021"
            ? `
                <dt>Are there any signature suites available?</dt>
                <dd>
                  Absolutely! If you want the ultimate experience, we recommend
                  <a href="/${trip}/prices/?tab=suites">booking a signature suite</a>.
                  We have a range of luxurious suite options available.
                </dd>
              `
            : `
              <dt>Are there any suites available?</dt>
              <dd>
                Absolutely! If you want the ultimate experience, we recommend
                <a href="/${trip}/prices/?tab=suites">booking a suite</a>.
                We have a range of luxurious suite options available.
              </dd>
            `
        }
      </dl>
      ${
        otherTripLis.length
          ? `
              <dl>
                <dt>Do you offer any other trips?</dt>
                <dd>
                  We do! Check out our upcoming Love Song Getaways:<br />&nbsp;
                  <ul>${otherTripLis.join("")}</ul>
                </dd>
              </dl>
            `
          : ""
      }
      <dl>
        <dt>
          What is the cancellation policy for the Love Song Couples Getaway?
        </dt>
        <dd>
          <a
            target="_blank"
            class="with-icon"
            href="/policies/terms-${trip}"
          >
            <span>View the cancellation policy</span>
            <i class="fa fa-external-link"></i>
          </a>
          for the Love Song Couples Getaway ${year}. Everlasting Tours recommends
          purchasing travel/cancellation insurance.
          <a target="_blank" class="with-icon" href="${
            config.urls.insuranceReferral
          }">
            <span>Travel Guard</span>
            <i class="fa fa-external-link"></i>
          </a>
          is a travel insurance provider that can provide you with all of your
          travel/cancellation insurance needs. Please visit
          <a target="_blank" class="with-icon" href="${
            config.urls.insuranceReferral
          }">
            <span>Travel Guard</span>
            <i class="fa fa-external-link"></i>
          </a>
          to find out more about the many benefits of travel insurance and to
          purchase travel/cancellation insurance.
        </dd>
      </dl>
      <dl>
        <dt>Can we bring our children?</dt>
        <dd>
          This is a couple’s only event.  We provide an atmosphere where you
          and your spouse can separate from the stresses of day-to-day life
          and focus on your relationship with each other and the Lord. Children
          are not permitted on the Love Song Couples Getaway.  Thank you for
          your understanding.
        </dd>
      </dl>
      <dl>
        <dt>Is this a cruise?</dt>
        <dd>
          No, it’s much better! Each Love Song Couples Getaway takes place at
          a top-rated resort and provides you with the opportunity to really
          experience the destination rather than just quickly sample it.  Plus,
          our high quality accommodations are typically 2x to 3x larger than a
          cruise state room and our getaways are up to 50% longer in duration
          than most cruises (with no “Days at Sea”), which gives you more space
          and time to relax and truly “getaway”.
        </dd>
      </dl>
    `;

    const preTripHtml = `
      <h1>Pre-Trip Information</h1>
      <dl>
        <dt>How do we book our airfare and what airport should we fly into?</dt>
        <dd>
          We recommend booking your airfare with your preferred airline
          or travel search website.  You will need to book your flight
          into the ${tripData.departureAirport} Airport
          (Airport Code: ${tripData.departureAirCode}).
        </dd>
      </dl>
      <dl>
        <dt>When should we schedule our flight to arrive and depart?</dt>
        <dd>
          Your inbound flight to ${tripData.departureAirport} Airport
          (Airport Code: ${tripData.departureAirCode}) needs to arrive prior
          to ${tripData.arrivePriorTo} on ${tripData.checkInDate}, to
          ensure that you have time to unpack and refresh prior to the
          Grand Opening of the Love Song Couples Getaway
          at ${tripData.startTime}.  Your outbound flight to your home
          airport can depart anytime on the last day of your trip,
          however check-out at the resort is at ${tripData.checkOutTime}.
        </dd>
      </dl>
      ${
        trip === "cancun"
          ? `
            <dl>
              <dt>Do we need a passport?</dt>
              <dd>
                Yes, both US and Mexico Immigration Laws require all travelers to
                have and travel with a valid passport.  Possession of proper
                documentation is the responsibility of the passenger. For more
                information, please visit the
                <a href=${config.urls.passport} target="_blank"
                >U.S. Passports & International Travel website</a>.
              </dd>
            </dl>
          `
          : ""
      }
      <dl>
        <dt>What types of dining options are available?</dt>
        <dd>
          ${
            trip.match(/cancun/)
              ? `
                Dining options in ${tripData.name} are endless! Everyone does
                their own thing for meals. There are many restaurants within a
                close proximity to the resort, offering travelers a selection
                of gourmet cuisines from around the world, including Mexican,
                French, Italian, American, Argentinean, Mediterranean, and
                Japanese, among others. Not to mention, the restaurants
                at ${tripData.venue}, are top-notch!
              `
              : trip === "maui2018"
              ? `
                Maui offers a vast array of culinary delights! Everyone does
                their own thing for meals. There are many restaurants within
                a close proximity to the resort in Kapalua and down the road
                in neighboring Ka’anapali. Plus, each of the six restaurants
                at ${tripData.venue} offers a unique experience, yet all
                reflect the culture and culinary traditions of ${tripData.name}.
              `
              : trip === "maui2019"
              ? `
                Maui offers a vast array of culinary delights! Everyone does
                their own thing for meals. There are many restaurants within
                a close proximity to the resort in Kapalua and down the road
                in neighboring Ka’anapali. Plus, each of the six restaurants
                at ${tripData.venue} offers a unique experience, yet all
                reflect the culture and culinary traditions of ${tripData.name}.
              `
              : trip === "maui2021"
              ? `
                Maui offers a vast array of culinary delights! Everyone does
                their own thing for meals. There are many restaurants within
                a close proximity to the resort in Wailea and down the road
                in neighboring Kihei. Plus, each of the restaurants
                at ${tripData.venue} offers a unique experience, yet all
                reflect the culture and culinary traditions of ${tripData.name}.
              `
              : trip.match(/kauai/)
              ? `
                The Grand Hyatt Kauai Resort and Spa is located in a very
                convenient area with quite a few dining options right up the
                road.
                <a
                  target="_blank"
                  class="with-icon"
                  href="http://www.theshopsatkukuiula.com/directory#dine"
                >
                  <span>The Shops at Kukui’ula</span>
                  <i class="fa fa-external-link"></i>
                </a>
                and the
                <a
                  target="_blank"
                  class="with-icon"
                  href="http://poipushoppingvillage.com/directory/dining/"
                >
                  <span>Poipu Shopping Village</span>
                  <i class="fa fa-external-link"></i>
                </a>
                have great restaurant options (including Bubba’s Burgers, Savage Shrimp,
                Lapperts Ice Cream, Starbucks and more!) in all price ranges, plus
                convenience stores where you can pick up snacks, drinks, etc…
              `
              : ""
          }
        </dd>
      </dl>
      <dl>
        <dt>How do we get to the hotel?</dt>
        <dd>
          ${
            trip === "cancun2020"
              ? `
                You will need to arrange for your own transportation to/from
                the resort/airport.
              `
              : trip.match(/maui2019|kauai/)
              ? `
                You will need to arrange for your own transportation to/from
                the resort/airport. Valet Parking Fee: $30 USD daily
                (plus tax, and is subject to change without notice)
              `
              : trip === "maui2018"
              ? `
                You will need to arrange for your own transportation to/from
                the resort/airport. Valet Parking Fee: $35 USD daily
                (plus tax, and is subject to change without notice)
              `
              : trip === "maui2019"
              ? `
                You will need to arrange for your own transportation to/from
                the resort/airport. Valet Parking Fee: $35 USD daily
                (plus tax, and is subject to change without notice)
              `
              : trip === "maui2021"
              ? `
                You will need to arrange for your own transportation to/from
                the resort/airport. Valet Parking Fee: $35 USD daily
                (plus tax, and is subject to change without notice)
              `
              : ""
          }
        </dd>
      </dl>
      <dl>
        <dt>
          When will we receive the final trip itinerary and more information
          about the optional activities?
        </dt>
        <dd>
          You will receive the final trip itinerary with a link to purchase
          optional activities via email, approximately 30 days prior to your
          trip departure. The itinerary will list out all of the scheduled
          events with times and locations.
        </dd>
      </dl>
      <dl>
        <dt>What type of clothing should we bring?</dt>
        <dd>
          Casual attire is recommended for the majority of the trip. For
          speaking engagements, concerts, and optional activities we
          recommend casual resort wear.
        </dd>
      </dl>
      <dl>
        <dt>How do we get into each event?</dt>
        <dd>
          You will be provided with a Love Song Entertainment Wristband
          when you check-in. The Wristband is required to enter into each
          event.
        </dd>
      </dl>
      <dl>
        <dt>
          Is attendance at any of the speaking sessions or performances required?
        </dt>
        <dd>
          Attendance is not required at any of the speaking sessions or
          performances.  It is completely up to you to decide which speaking
          sessions or performances you want to attend, but they are so amazing
          we don’t think you’ll want to miss any of them!
        </dd>
      </dl>
    `;

    const covidHtml = `
      <h1>Health & Safety Information</h1>
      <dl>
        <dt>Are there any entry requirenments to Maui?</dt>
        <dd>
The entry requirenments are very straightforward.  All transpacific travelers arriving into Maui are required to have a negative Covid-19 test result from a "Trusted Travel Partner" taken within the 72 hours before departure of the final leg of their trip to Hawai‘i, and to complete the Safe Travels Hawaii form online in order to bypass the 10-day quarantine. The form will generate a unique QR code which must be scanned on arrival. Negative tests must be uploaded here and a questionnaire must be completed ahead of travel (24 hours prior recommended).  Possession of proper documentation is the responsibility of each passenger.
        </dd>
      </dl>
      <dl>
      <dt>What safety measures will be in place on the getaway?</dt>
        <dd>
This event will be run in accordance to the state regulations in place at the time of the event in regards to social distancing and face covering requirements.  Travelers are responsible for all Covid-19 related requirements and costs that travel suppliers and governments may impose, such as pre-travel testing, health screenings prior to departure or upon arrival, health affidavit forms, face coverings, or quarantines etc.
        </dd>
      </dl>
    `;

    return (
      <div className={`page-faq trip-${trip}`}>
        <HelmetWrapper
          metaTitle={metaTitle}
          metaDescription={metaDescription}
        />
        <div className="bookmark" id="top" />
        <SiteHeader trip={trip} />
        <main>
          <div
            style={{ backgroundImage: `url(/images/faq-${trip}-splash.jpg)` }}
            className="image mobile-100x40 desktop-400"
          />
          <TabbedContent
            willAnchor
            replaceState={`/${trip}/faq/`}
            selectedKey={selectedKey}
            title="Frequently Asked Questions"
            data={JSON.stringify([
              {
                key: "all",
                name: "All",
                slug: "",
                body: `${bookingHtml}<br /><br /><br />${preTripHtml}<br /><br /><br />${covidHtml}`,
              },
              {
                key: "booking",
                name: "Booking",
                slug: "?tab=booking",
                body: bookingHtml,
              },
              {
                key: "pre-trip",
                name: "Pre-Trip Info",
                slug: "?tab=pre-trip",
                body: preTripHtml,
              },
              {
                key: "covid",
                name: "Health & Safety Info",
                slug: "?tab=covid",
                body: covidHtml,
              },
            ])}
          />
          <div className="content">
            <div className="wrap arrow-bar">
              <BookmarkArrow bookmark="top" direction="up" />
            </div>
          </div>
        </main>
        <SiteFooter trip={trip} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/faq.js